import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './fonts';

/**
 * Application Entry Point
 * 
 * This file bootstraps the React application:
 * 1. Imports i18n configuration for internationalization
 * 2. Creates the React root on the #root DOM element
 * 3. Renders the main App component in StrictMode
 * 
 * StrictMode helps identify potential problems:
 * - Detects unsafe lifecycles
 * - Warns about legacy string ref API usage
 * - Warns about deprecated findDOMNode usage
 * - Detects unexpected side effects
 */

// Get the root DOM element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element. Make sure index.html contains a div with id="root"');
}

// Create React root and render the application
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
